import { IDataJsonSdl, IDataJsonUrlSdl } from "../../components/types/Types";
import getFetchUrl from "../getFetchUrl";

export const fetchSdlDataJsonUrl = async (listView: string) =>
  await fetch(getFetchUrl(), {
    method: "POST",

    body: JSON.stringify({
      query: `query{
      items(
        filter: {itemTypes: [COMPONENT], namespaceIds: [1],  
          customMeta: {key: "ApplicationTag", value: "openpages"},
          and:{customMeta: {key: "ApplicationPageTag", value: "${listView}"},
          and:{customMeta: {key: "ApplicationContentTag", value: "json"}}}
        } ) {
        edges {
          node {
            ... on BinaryComponent   {
              variants{
                  edges{
                      node{
                          path
                      }
                  }
              }
            }
          }
        }
      }
    }`,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response: Response) => {
      return response.json();
    })
    .then((responseJson: IDataJsonUrlSdl) => {
      return responseJson;
    })
    // eslint-disable-next-line no-console
    .catch((error) => {
      throw new Error(`Could not get json url ${error}`);
    });

export const fetchSdlDataJson = async (selectedUrl: string) =>
  fetch(selectedUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response: Response) => {
      return response.json();
    })
    .then((response: IDataJsonSdl) => {
      return response;
    })
    // eslint-disable-next-line no-console
    .catch((error) => {
      throw new Error(`Could not get json data ${error}`);
    });
